<template>
  <UModal
    v-model:open="isOpen"
    :title="t('comps.modal_email_confirmed.title', { name: user.first_name ? ` ${user.first_name}` : '' })"
  >
    <template #body>
      <!-- <LayoutH2>{{ t('comps.modal_email_confirmed.title', { name: user.first_name ? ` ${user.first_name}` : '' }) }}</LayoutH2> -->

      <IconsThumbUp />

      <LayoutP>{{ t("comps.modal_email_confirmed.text") }}</LayoutP>
      <div class="flex justify-center">
        <UButton
          class="self-center mx-auto mt-6"
          :label="t('comps.modal_email_confirmed.btn_close')"
          size="xl"
          @click="isOpen = false"
        />
      </div>
    </template>
  </UModal>
</template>

<script lang="ts" setup>
import { UButton } from '#components'

const isOpen = ref(false)
const user = useUserStore()

onMounted(async () => {
  const route = useRoute()

  if (route.query['email_confirmed'] !== undefined) {
    isOpen.value = true
    const { event } = useTracker()

    event({
      meta: 'EmailConfirmed',
      google: 'email_confirmed',
      snapchat: 'CUSTOM_EVENT_1',
    })

    const query = { ...route.query }
    delete query['email_confirmed']

    await navigateTo({
      path: route.path,
      query,
    }, { replace: true })
  }
})
</script>
